import React, {useState, useEffect} from 'react';
import {Col, Dropdown, DropdownMenu, DropdownToggle, Nav, NavItem, NavLink, Row, TabContent, TabPane} from 'reactstrap';
import {Link} from 'react-router-dom';
import classnames from 'classnames';

//import images
import avatar2 from "../../assets/images/users/avatar-2.jpg";
import avatar8 from "../../assets/images/users/avatar-8.jpg";
import avatar3 from "../../assets/images/users/avatar-3.jpg";
import avatar6 from "../../assets/images/users/avatar-6.jpg";
import bell from "../../assets/images/svg/bell.svg";

//SimpleBar
import SimpleBar from "simplebar-react";
import Swal from "sweetalert2";
import AuthService from "../../admin/components/util/AuthService";
import ApiService from "../../admin/components/util/ApiService";
import Skeleton from "react-loading-skeleton"; // Importando Skeleton para carregamento
import 'react-loading-skeleton/dist/skeleton.css';

import {CSSTransition, TransitionGroup} from "react-transition-group";
import ImportModal from "../../admin/components/import/ImportModal";
import DutyDetailModal from "../../admin/components/dashboard/calender/dutyDetailModal";
import PlantaoModal from "../../admin/components/dashboard/calender/plantaoModal";
import PlantaoRepostModal from "../../admin/components/dashboard/calender/plantaoRepostModal"; // Importando CSSTransition e TransitionGroup
const NotificationDropdown = () => {
    //Dropdown Toggle
    const [isNotificationDropdown, setIsNotificationDropdown] = useState(false);
    const user = AuthService.getUserData();
    const [selectedCompany, setSelectedCompany] = useState(null);


    function getRating(rating) {
        switch (rating) {
            case 1:
                return "Ruim";
            case 2:
                return "Nada especial";
            case 3:
                return "Mediano";
            case 4:
                return "Muito bom";
            case 5:
                return "Excelente";
            default:
                return "Nenhum";
        }
    }


    const [search, setSearch] = useState("");
    const [loadingPage, setLoadingPage] = useState(false);
    const [loadingUser, setLoadingUser] = useState(true);
    const [selectedNotification, setSelectedNotification] = useState(null);
    const [loadingNotifications, setLoadingNotifications] = useState(true);
    const [notifications, setNotifications] = useState([]);
    const [hospitalRating, setHospitalRating] = useState(0);
    const [userRating, setUserRating] = useState(0);
    const [notificationsTotal, setNotificationsTotal] = useState(null);
    const [hoveredUserRating, setHoveredUserRating] = useState(0); // Avaliação durante o hover do responsável
    const [feedbackHospital, setFeedbackHospital] = useState(""); // Feedback do hospital
    const [feedbackResponsavel, setFeedbackResponsavel] = useState(""); // Feedback do responsável

    const [selectedDuty, setSelectedDuty] = useState(null);
    const [duty, setDuty] = useState([]);// Estado para o dever selecionado
    const [modalVisible, setModalVisible] = useState(false); // Estado para a visibilidade do modal
    const [showDutyModal, setShowDutyModal] = useState(false);
    const [showPlantaoRepostModal, setShowPlantaoRepostModal] = useState(false);

    const fetchNotifications = async () => {
        try {
            setLoadingNotifications(true);
            const response = await ApiService.send("get", `${process.env.REACT_APP_URL_API}notification/list`, {read: '0'}, true);


            const {data} = ApiService.handleApiResponse(response);

            setNotifications(data);
            setLoadingNotifications(false);
        } catch (error) {
            ApiService.handleApiError(error);
        }
    };


    const [logos, setLogos] = useState({
        logo: '',
        smallLogo: '',
    });
    const domain = window.location.hostname;


    useEffect(() => {
        // Recupera os logos do localStorage


        const user = AuthService.getUserData();


        const cachedImages = JSON.parse(localStorage.getItem(`custom_images_${domain}`)) || {};
        setLogos({
            logo: cachedImages.logo || "/default-logo.png",
            smallLogo: cachedImages.smallLogo || "/default-small-logo.png",
        });

        if (loadingUser && user && user?.companies) {
            setSelectedCompany(user.companies?.find(c => c.selected) || user.companies[0]);
            setLoadingUser(false)
        }
        fetchNotificationsTotal();
        fetchNotifications();
    }, []);

    const toggleNotificationDropdown = () => {
        setIsNotificationDropdown(!isNotificationDropdown);
    };


    //Tab
    const [activeTab, setActiveTab] = useState('1');
    const toggleTab = (tab) => {
        if (activeTab !== tab) {
            setActiveTab(tab);
        }
    };

    const fetchNotificationsTotal = async () => {
        try {
            const response = await ApiService.send("get", `${process.env.REACT_APP_URL_API}notification/notificationTotal`, [], true);


            const {data} = ApiService.handleApiResponse(response);
            setNotificationsTotal(data?.notRead);
        } catch (error) {
            ApiService.handleApiError(error);
        }
    };

    const handleSaveRatings = () => {
        setLoadingPage(true);

        ApiService.send("post", `${process.env.REACT_APP_URL_API}users/rating`, {
            notification_id: selectedNotification.id,
            duty_id: selectedNotification.id_duty,
            rated_user_id: selectedNotification.data.id_user_duty,
            rating: userRating,
            comment: feedbackResponsavel,
            rated_hospital_id: selectedNotification.data.hospital_id,
            rating_hospital: hospitalRating,
            feedback_hospital: feedbackHospital,
        })
            .then((response) => {
                // Requisição bem-sucedida
                setLoadingPage(false);
                Swal.fire({
                    title: "Sucesso!",
                    text: "Avaliação salva com sucesso!",
                    icon: "success",
                    confirmButtonText: "OK",
                });

                const modal = Modal.getInstance(document.getElementById("ratingsModal"));
                modal.hide();
            })
            .catch((error) => {
                setLoadingPage(false);
                Swal.fire({
                    title: "Erro!",
                    text: error.response?.data?.message || "Ocorreu um erro inesperado. Por favor, tente novamente.",
                    icon: "error",
                    confirmButtonText: "OK",
                });
            });
    };


    useEffect(() => {
        // Verifique se o total de notificações é maior que zero e o array de notificações está vazio

        if (notificationsTotal > 0 && notifications.length === 0) {
            fetchNotifications();
        }
    }, [notifications, notificationsTotal]);

    const handleDeleteNotification = (id, event) => {
        event.stopPropagation(); // Impede que o dropdown seja fechado

        // Atualiza o total de notificações
        setNotificationsTotal((prevTotal) => (prevTotal > 0 ? prevTotal - 1 : 0));

        // Atualiza o array de notificações, removendo a notificação deletada
        setNotifications((prevNotifications) =>
            prevNotifications.filter((notification) => notification.id !== id)
        );

        // Faz a chamada para marcar a notificação como lida
        ApiService.send("put", `${process.env.REACT_APP_URL_API}notification/read`, {id: id, was_read: true}, true)
            .then(() => {

            })
            .catch((error) => {

            });
    };

    const handleMarkAllAsRead = async () => {
        try {
            await ApiService.send("put", `${process.env.REACT_APP_URL_API}notification/readAll`, {was_read: true}, true);
            setNotifications([]);
            setNotificationsTotal(0); // Zera o total de notificações não lidas

            // Caso ainda haja notificações não lidas, busque novamente
            if (notificationsTotal > 0) {
                fetchNotifications();
            }
        } catch (error) {
            ApiService.handleApiError(error);
        }
    };

    const handleSidebar = () => {
        document.body.classList.toggle("mini-sidebar");
    };

    const handleSidebarMobileMenu = () => {
        document.body.classList.toggle("slide-nav");
    };


    const modalRatings = (notification) => {
        setHospitalRating(0);
        setUserRating(0);

        if (typeof notification.data === "string") {
            notification.data = JSON.parse(notification.data);
        }

        setSelectedNotification(notification);
        const modal = new Modal(document.getElementById("ratingsModal"));
        modal.show();
    };

    const handleDropdownClick = () => {
        const dropdownElement = document.getElementById('notificationDropdown');
        const toggleButton = document.getElementById('notificationDropdownToggle');

        if (dropdownElement && toggleButton) {
            dropdownElement.classList.add('show');
            dropdownElement.setAttribute('aria-expanded', 'true');
            toggleButton.classList.add('show');
        }

        fetchNotifications();
    };

    const handleCompanySelect = async (company) => {
        try {
            setSelectedCompany(company);

            // Atualiza no estado local
            const updatedCompanies = user.companies?.map(c => ({
                ...c,
                selected: c.user_id === company.user_id ? 1 : 0
            }));

            // Atualiza no localStorage
            AuthService.setUserValue("companies", updatedCompanies);
            // Envia a atualização para o backend
            const response = await ApiService.send(
                "post",
                `${process.env.REACT_APP_URL_API}documents/update-selected`,
                {company_id: company.user_id},
                true
            );

            if (response.code === 200) {

            } else {
                console.error("Erro ao atualizar empresa no backend:", response.data?.message || "Erro desconhecido");
            }
        } catch (error) {
            ApiService.handleApiError(error);
        }
    };


    // Filtra empresas conforme a busca
    const filteredCompanies = user?.companies?.filter(company =>
        company.name.toLowerCase().includes(search.toLowerCase())
    ) || [];


    const handleDutyClick = (duty) => {
        setSelectedDuty(duty);
        setModalVisible(true);
    };

    const handleModalClose = () => {
        setModalVisible(false);
        setSelectedDuty(null);
    };

    const handlePlantaoModalClose = () => {
        setShowDutyModal(false);
    };
    const handlePlantaoRepostModalClose = () => {
        setShowPlantaoRepostModal(false);
    };


    return (
        <React.Fragment>
            <Dropdown isOpen={isNotificationDropdown} toggle={toggleNotificationDropdown}
                      className="topbar-head-dropdown ms-1 header-item">
                <DropdownToggle type="button" tag="button"
                                className="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle">
                    <i className='bx bx-bell fs-22'></i>
                    <span
                        className="position-absolute topbar-badge fs-10 translate-middle badge rounded-pill bg-danger">{notificationsTotal}<span
                        className="visually-hidden">unread messages</span></span>
                </DropdownToggle>
                <DropdownMenu className="dropdown-menu-lg dropdown-menu-end p-0">
                    <div className="dropdown-head bg-primary bg-pattern rounded-top">
                        <div className="p-3">
                            <Row className="align-items-center">
                                <Col>
                                    <h6 className="m-0 fs-16 fw-semibold text-white"> Notificações </h6>
                                </Col>
                                <div className="col-auto dropdown-tabs">
                                    <span
                                        className="badge bg-light-subtle text-body fs-13">{notificationsTotal} Novas</span>
                                </div>
                            </Row>
                        </div>

                        <div className="px-2 pt-2">
                            <Nav className="nav-tabs dropdown-tabs nav-tabs-custom">
                                <NavItem>
                                    <NavLink
                                        href="#"
                                        className={classnames({active: activeTab === '1'})}
                                        onClick={() => {
                                            toggleTab('1');
                                        }}
                                    >
                                        Todas ({notificationsTotal})
                                    </NavLink>
                                </NavItem>
                            </Nav>
                        </div>

                    </div>

                    <TabContent activeTab={activeTab}>
                        <TabPane tabId="1" className="py-2 ps-2">
                            <SimpleBar style={{maxHeight: "300px"}} className="pe-2">


                                <div className="noti-content">
                                    {loadingNotifications ? (
                                        <Skeleton count={5} height={60} className="mb-2"/>
                                    ) : notifications.length > 0 ? (
                                        <TransitionGroup component={null}>
                                            {notifications.map((notification) => (
                                                <CSSTransition
                                                    key={notification.id}
                                                    timeout={500}
                                                    classNames="fade-scale"
                                                >
                                                    <div
                                                        id={`notification-${notification.id}`}
                                                        className="notification-item card mb-2 shadow-sm position-relative"
                                                    >
                                                        {/* Botão de fechar no canto superior direito */}
                                                        <button
                                                            className="close-button position-absolute top-0 end-0 m-2 btn btn-sm btn-light"
                                                            onClick={(event) => handleDeleteNotification(notification.id, event)}
                                                        >
                                                            <i className="fa fa-close"></i>
                                                        </button>

                                                        <div className="card-body">
                                                            <h6 className="card-title">{notification.title}</h6>
                                                            <p className="card-text">{notification.body}</p>

                                                            <div className="row">
                                                                <div className="col-4">
                                                                    {notification.type_notification_id === 6 && (
                                                                        <button
                                                                            className="btn btn-primary btn-sm me-2"
                                                                            onClick={() => modalRatings(notification)}
                                                                        >
                                                                            <i className="fa fa-edit"></i> Avaliar
                                                                        </button>
                                                                    )}

                                                                    <button
                                                                        className="btn btn-sm btn-success me-2"
                                                                        onClick={() => handleDutyClick(notification)}
                                                                    >
                                                                      Detalhes
                                                                    </button>
                                                                </div>
                                                                <div className="col-8 text-end">
                                                                    <small className="text-muted">
                                                                        {new Date(notification.created_at).toLocaleString('pt-BR', {
                                                                            day: '2-digit',
                                                                            month: '2-digit',
                                                                            year: 'numeric',
                                                                            hour: '2-digit',
                                                                            minute: '2-digit',
                                                                            hour12: false,
                                                                        })}

                                                                    </small>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                </CSSTransition>
                                            ))}
                                        </TransitionGroup>
                                    ) : (
                                        <div className="alert alert-primary" role="alert">Nenhuma notificação
                                            encontrada
                                        </div>
                                    )}
                                </div>


                                <div className="my-3 text-center">
                                    <Link className="btn btn-soft-success waves-effect waves-light"
                                          to="/admin/notification-list">Ver todas as notificações</Link>
                                </div>
                            </SimpleBar>

                        </TabPane>

                    </TabContent>
                </DropdownMenu>
            </Dropdown>

            {selectedDuty && (
                <DutyDetailModal
                    show={modalVisible}
                    handleClose={handleModalClose}
                    eventDetails={selectedDuty}
                    onRepost={(event) => {
                        setSelectedDuty(false);
                        setDuty(event);
                        setShowPlantaoRepostModal(true);
                    }}
                    onEdit={(event) => {
                        setSelectedDuty(false);
                        setDuty(event);
                        setShowDutyModal(true);
                    }}
                />
            )}

            {/* Modal de cadastro de plantão */}
            {showDutyModal && (
                <PlantaoModal
                    show={showDutyModal}
                    handleClose={handlePlantaoModalClose}
                    duty={duty}
                />
            )}

            {showPlantaoRepostModal && (
                <PlantaoRepostModal
                    show={showPlantaoRepostModal}
                    handleClose={handlePlantaoRepostModalClose}
                    duty={duty}
                />
            )}


        </React.Fragment>
    );
};

export default NotificationDropdown;
